import { render, staticRenderFns } from "./PlanVenteTreeNode.vue?vue&type=template&id=24d1520c&scoped=true&"
import script from "./PlanVenteTreeNode.vue?vue&type=script&lang=js&"
export * from "./PlanVenteTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./PlanVenteTreeNode.vue?vue&type=style&index=0&id=24d1520c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1520c",
  null
  
)

component.options.__file = "PlanVenteTreeNode.vue"
export default component.exports